import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import LoaderProvider from './components/Loader/LoaderProvider';
import Loader from './components/Loader/Loader';
import { toast } from 'react-toastify';

let hasRefreshed = false;
const PWA_UPDATE_TOAST_ID = 'pwa-update-ready';

const activateUpdate = (registration) => {
  if (registration && registration.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  } else {
    window.location.reload();
  }
};

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hasRefreshed) {
      return;
    }

    hasRefreshed = true;
    window.location.reload();
  });
}

ReactDOM.render(
  <React.StrictMode>
    {/* <App /> */}
    <LoaderProvider>
      <Loader /> {/* Always mounted */}
      <App />
    </LoaderProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    toast.info(
      <div className="pwa-update-toast">
        <div className="pwa-update-title">New version is ready</div>
        <div className="pwa-update-message">Refresh now to use the latest updates.</div>
        <button
          type="button"
          className="pwa-update-action"
          onClick={() => activateUpdate(registration)}
        >
          Refresh App
        </button>
      </div>,
      {
        toastId: PWA_UPDATE_TOAST_ID,
        autoClose: false,
        closeOnClick: false,
        draggable: false,
      }
    );
  },
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
